import type { ButtonProps } from "@ecco/ui/button";
import type { BoxProps } from "@ecco/ui/box";
import { focusOutline } from "@ecco/ui/css/focus";

export const BORDER_LIGHT_GRAY = "1px solid #E6E6E6";
export const BORDER_BLACK = "1px solid black";

export interface SizeGridCellButtonStyleParams {
    isSelected: boolean;
    isAvailable: boolean;
    hasNotifySizeAvailability: boolean;
    isFootwear: boolean;
}

export const interactiveBlackFocus: Pick<ButtonProps, "_focus" | "_focusVisible"> = {
    _focus: { outline: "none", boxShadow: "none" },
    _focusVisible: { ...focusOutline, boxShadow: "none" },
};

export const sizeWrapperStyles = (isHighlighted: boolean) => ({
    borderColor: isHighlighted ? "red.500" : "none",
    borderStyle: isHighlighted ? "solid" : "none",
    borderWidth: isHighlighted ? "1px" : "0",
});

export const sizeSystemToggleButtonStyles = (isActive: boolean): ButtonProps => ({
    px: 2,
    py: 1,
    h: "auto",
    minH: "auto",
    type: "button",
    lineHeight: 1.3,
    fontWeight: 400,
    variant: "ghost",
    cursor: "pointer",
    fontSize: "14px",
    borderRadius: "md",
    _hover: { bg: "gray.100" },
    transition: "background-color 0.2s",
    textDecoration: isActive ? "underline" : "none",
    ...interactiveBlackFocus,
});

export const notifyBellStylesBox: BoxProps = {
    px: 0,
    py: 0,
    w: "auto",
    h: "auto",
    zIndex: 6,
    top: "2px",
    right: "2px",
    minW: "unset",
    lineHeight: 1.4,
    position: "absolute",
    color: "black",
    "aria-hidden": true,
    pointerEvents: "none",
    ...interactiveBlackFocus,
};

export const sizeGridCellButtonStyles = ({
    isSelected,
    isAvailable,
    hasNotifySizeAvailability,
    isFootwear,
}: SizeGridCellButtonStyleParams): ButtonProps => ({
    size: "md",
    width: "100%",
    type: "button",
    color: "black",
    translate: "no",
    variant: "unstyled",
    fontWeight: isSelected ? 700 : 400,
    bg: isAvailable ? "transparent" : "#F2F2F2",
    disabled: !isAvailable && !hasNotifySizeAvailability,
    border: isSelected ? BORDER_BLACK : BORDER_LIGHT_GRAY,
    "aria-disabled": !isAvailable && !hasNotifySizeAvailability,
    _disabled: {
        bg: "#F2F2F2",
        color: "black",
        cursor: "not-allowed",
        opacity: 1,
    },
    _hover: {
        border:
            isAvailable || (!isAvailable && hasNotifySizeAvailability)
                ? BORDER_BLACK
                : BORDER_LIGHT_GRAY,
        bg: isAvailable ? "transparent" : "#F2F2F2",
        color: "black",
    },
    _active: {
        bg: isAvailable ? "transparent" : "#F2F2F2",
    },
    ...interactiveBlackFocus,
    _focusVisible: {
        ...focusOutline,
        boxShadow: "none",
        color: "black",
        ...(isAvailable ? { bg: "transparent" } : { bg: "#F2F2F2" }),
    },
    ...(isFootwear ? { paddingX: 4 } : {}),
});
